import styles from './CircularLoader.module.css';
import type { CircularLoaderProps } from './types/CircularLoader';

const CircularLoader = ({
  color = '#3C3E4D',
  fullscreen = false,
  size = 48,
}: CircularLoaderProps) => {
  return (
    <div
      className={`${styles.loaderWrapper} ${fullscreen ? styles.fullscreen : ''}`}
      role="presentation"
    >
      <div
        className={styles.loader}
        style={{
          width: size,
          height: size,
          borderWidth: size * 0.1,
          borderTopColor: color,
          borderRightColor: color,
          borderBottomColor: color,
        }}
      />
    </div>
  );
};

export default CircularLoader;
